import { render } from "./List.vue?vue&type=template&id=35217ae3&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=35217ae3&scoped=true&lang=css"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35217ae3"]])

export default __exports__